import React, { useState, useEffect } from "react";
import Header from "../layout/Header";
import Toolbar from "../navigation/Toobar";
import Chat from "../components/common/Chat";


function Profile(){
  const [userData, setUserData] = useState({
        username: '',
        vip_coin: 0,
        name: '',
        phone: '',
        session_id: '',
        email: '',
        created_at: '',
        dofb: '',
    });
    const [isEditingBirthday, setIsEditingBirthday] = useState(false);
    const [dofb, setDofb] = useState('');
    const [name, setName] = useState(userData.name || "");
    const [email, setEmail] = useState(userData.email);
    const [verifyType, setVerifyType] = useState("");
    const [timer, setTimer] = useState(0); // Timer state for countdown
    const [isCodeSent, setIsCodeSent] = useState(false); // Track if verification code is sent
    const [verificationCode, setVerificationCode] = useState('');
    const [phoneNumber, setphoneNumber] = useState('');
    const [getotherContracts, setotherContracts] = useState([]);
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);
	
	const [showModal, setShowModal] = useState(false);
	const [modalMessage, setModalMessage] = useState('');

	const showMsg = (message) => {
		setModalMessage(message);
		setShowModal(true);
	};
    useEffect(() => {
  if (userData.name) {
    setName(userData.name);
    setEmail(userData.email);
  }
}, [userData]);

    const fetchUserData = async () => {
        const token = localStorage.getItem('token');
        const remoteId = localStorage.getItem('remote_id');
        if (token && remoteId) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/show?remote_id=${remoteId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    const formattedDate = data.created_at ? new Date(data.created_at).toLocaleDateString('en-GB') : 'N/A';

                    setUserData({
                        username: data.username || 'Unknown User',
                        vip_coin: data.vip_coin || 0,
                        name: data.name || 'N/A',
                        phone: data.phone || '',
                        email: data.email || '',
                        session_id: data.session_id || '',
                        created_at: formattedDate,
						dofb: data.dofb || '',
						email_verified_at: data.email_verified_at || null,
                    });

                    // Automatically enable birthday editing if dofb is null or empty
                    if (!data.dofb) {
                        setIsEditingBirthday(true);
                    }
                    setDofb(data.dofb || '');
                } else {
                    console.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        }
    };
    const fetchOther = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setotherContracts(data.data || []);
                   
                   
                } else {
                    console.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        }
    };
    const updateProfile = async () => {
        const token = localStorage.getItem('token');
        const remoteId = localStorage.getItem('remote_id');
        if (token && remoteId && dofb) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/profile/update`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        remote_id: remoteId,
                        dofb: dofb,
                        name: name,
                        email: email,
                    }),
                });

                if (response.ok) {
                    const data = await response.json();
                    setUserData((prevUserData) => ({
                        ...prevUserData,
                        dofb: data.dofb || dofb,
                    }));
                    setIsEditingBirthday(false); // Turn off editing mode after updating
                } else {
                    showMsg('Failed to update DOFB');
                }
            } catch (error) {
                console.error('Error updating DOFB:', error);
            }
        }
    };

    const verfiyPhoneNumber = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/verify-phone-number`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        verification_code: verificationCode, 
                    }),
                });

                if (response.ok) {
                    const data = await response.json();
					console.log(data); // Handle the response
					fetchUserData();
					fetchOther();
                } else {
                    console.error('Failed to send code');
                }
            } catch (error) {
                console.error('Error send code:', error);
            }
        }
	};
	
    const verfiyEmail = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/verify-email`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        code: verificationCode, 
                    }),
                });

                if (response.ok) {
                    const data = await response.json();
					console.log(data); // Handle the response
					// refresh
					fetchUserData();
					fetchOther();
				} else {
					let errorData = await response.json();
					let msg = errorData.message || 'Failed to send code';
					showMsg(msg);
                }
            } catch (error) {
                console.error('Error send code:', error);
            }
        }
    };
    const addverfiyPhoneNumber = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/add/verify-phone-number`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        verification_code: verificationCode,
                    }),
                });

                if (response.ok) {
                    const data = await response.json();
					console.log(data); // Handle the response
					fetchUserData();
					fetchOther();
                } else {
                    console.error('Failed to send code');
                }
            } catch (error) {
                console.error('Error send code:', error);
            }
        }
    };

    const verfiyPhonCode = async () => {
        if (isButtonDisabled) return; // Prevent second click

        setIsButtonDisabled(true); // Disable the button after the first click

        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/send-verification-code`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        phone: userData.phone,
                
                    }),
                });
    
                if (response.ok) {
                    setIsCodeSent(true);
                    setTimer(5 * 60); // Start a 5-minute timer
                    const countdown = setInterval(() => {
                        setTimer((prevTime) => {
                            if (prevTime <= 0) {
                                clearInterval(countdown);
                                return 0;
                            }
                            return prevTime - 1;
                        });
                    }, 1000);
                } else {
                    console.error('Failed to send code');
                }
            } catch (error) {
                console.error('Error sending code:', error);
            }
        } else {
            console.error('Verification code is required');
        }
	};

    const verfiyEmailCode = async () => {
        if (isButtonDisabled) return; // Prevent second click

        setIsButtonDisabled(true); // Disable the button after the first click

        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/send-verification-code`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        email: userData.email
                    }),
                });
    
                if (response.ok) {
                    setIsCodeSent(true);
                    setTimer(5 * 60); // Start a 5-minute timer
                    const countdown = setInterval(() => {
                        setTimer((prevTime) => {
                            if (prevTime <= 0) {
                                clearInterval(countdown);
                                return 0;
                            }
                            return prevTime - 1;
                        });
                    }, 1000);
                } else {
                    let errorData = await response.json();
					let msg = errorData.message || 'Failed to send code';
					showMsg(msg);
                }
            } catch (error) {
                console.error('Error sending code:', error);
            }
        } else {
            console.error('Verification code is required');
        }
	};
	


    const addPhoneNumber = async () => {
        if (isButtonDisabled) return;
    
        setIsButtonDisabled(true);
    
        const token = localStorage.getItem('token');
        if (!token) {
            console.error('User token not found.');
            setIsButtonDisabled(false);
            return;
        }
    
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/add/number`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ phone: phoneNumber }),
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                console.error('Failed to add phone number:', errorData.message || 'Unknown error');
                setIsButtonDisabled(false);
                return;
            }
    
            const verifyResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/add/send-verification-code`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ phone: phoneNumber }),  // এখানে userData.phone নয়, phoneNumber পাঠানো হয়েছে
            });
    
            if (!verifyResponse.ok) {
                const errorData = await verifyResponse.json();
                console.error('Failed to send verification code:', errorData.message || 'Unknown error');
                setIsButtonDisabled(false);
                return;
            }
    
            setIsCodeSent(true);
            setTimer(5 * 60);
    
            let countdown = setInterval(() => {
                setTimer((prevTime) => {
                    if (prevTime <= 0) {
                        clearInterval(countdown);
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
    
        } catch (error) {
            console.error('Error sending code:', error);
            setIsButtonDisabled(false);
        }
    };
    

    useEffect(() => {
        fetchUserData();
		fetchOther();
    }, []);

    const OpenPOP = (type) => {
        setVerifyType(type);
        
    };

    const ClosePOP = () => {
        setVerifyType("");
        
    };
    return(
  <div className="v-application--wrap">
  <div>
    <div className="row no-gutters">
     <Header/>
    </div>
    <div className="body">
      <div className="profileLayout-padding margin-desktop">
        <div className="row mobile-full-height no-gutters">
          <div className="col col-12">
            <div style={{height: '100%'}}>
              <div className="v-card v-sheet theme--light desktop_card">
                <div className="v-card__title">
                  <label className="--v-primary-base text-left text-capitalize mr-4">My profile</label>
                  <button onClick={() => OpenPOP('edit')} type="button" className="icon-btn v-btn v-btn--icon v-btn--round theme--light v-size--default">
                    <span className="v-btn__content">
                      <svg xmlns="http://www.w3.org/2000/svg" width={21} height="20.944" className>
                        <defs />
                        <path d="M20.993 3.183c-.046.178-.079.356-.132.534a3.081 3.081 0 01-.784 1.252q-4.843 4.843-9.693 9.686a1.419 1.419 0 01-.507.323c-1.417.488-2.84.949-4.263 1.43a.83.83 0 01-.784-.066.779.779 0 01-.25-.936c.369-1.107.778-2.2 1.094-3.321a4.9 4.9 0 011.371-2.214c2.965-2.919 5.9-5.864 8.83-8.81a3.21 3.21 0 011.9-1.041c.013 0 .02-.013.033-.02h.659a.26.26 0 00.092.033 2.82 2.82 0 012.306 1.957 5.537 5.537 0 01.138.547c-.01.211-.01.428-.01.646z" className="a" />
                        <path d="M.013 11.215V3.776a2.233 2.233 0 011.845-2.254 2.635 2.635 0 01.507-.04h8.751c.514 0 .83.244.87.672a.729.729 0 01-.7.817c-.079.007-.165 0-.244 0H2.418a1.33 1.33 0 00-.362.04.71.71 0 00-.534.626 3.332 3.332 0 00-.013.264v14.628a2.04 2.04 0 00.013.283.721.721 0 00.633.626 1.767 1.767 0 00.264.013H15.57c.072 0 .152 0 .224-.007a.721.721 0 00.685-.712c.013-.283.007-.573.007-.863v-6.5a1.511 1.511 0 01.053-.422.738.738 0 011.41.053 1.187 1.187 0 01.033.3c0 2.438.007 4.876 0 7.314a2.246 2.246 0 01-1.746 2.26 2.333 2.333 0 01-.567.059H2.313A2.24 2.24 0 010 18.628c.013-2.451.013-4.935.013-7.413z" className="a" />
                      </svg>
                    </span>
                  </button>
                </div>
                <div className="profile-detail-card v-card v-sheet theme--light elevation-0">
                  <div className="row px-8 pa-4 hidden-md-and-up no-gutters align-end">
                    <div className="col-md-3 col-lg-2 col"><label className="field-name">Email</label></div>
                    <div className="col-md-9 col-lg-10 col"> {userData.email}<label /></div>
                    <div className="col col-12"><hr role="separator" aria-orientation="horizontal" className="v-divider theme--light" /></div>
                  </div>
                  <div className="row px-8 pa-4 hidden-md-and-up no-gutters align-end">
                    <div className="col-md-3 col-lg-2 col"><label className="field-name">Username</label></div>
                    <div className="col-md-9 col-lg-10 col"><label>{userData.username}</label></div>
                    <div className="col col-12"><hr role="separator" aria-orientation="horizontal" className="v-divider theme--light" /></div>
                  </div>
                  <div className="row px-8 pa-4 hidden-md-and-up no-gutters align-end">
                    <div className="col-md-3 col-lg-2 col"><label className="field-name">Date of birth</label></div>
                    <div className="col-md-9 col-lg-10 col">{userData.dofb}<label /></div>
                    <div className="col col-12"><hr role="separator" aria-orientation="horizontal" className="v-divider theme--light" /></div>
                  </div>
                 
                  <div className="row px-8 pa-4 hidden-md-and-up no-gutters align-end">
                    <div className="col-md-1 col-lg-1 col-0"><label className="field-name">Primary Number</label></div>
                    <div className="phoneNo col-md-9 col-lg-10 col">
                      <label>+88 {userData.phone}</label>
                      {userData.session_id !== '1' &&(
                          <>
                           <div  onClick={() => userData.session_id !== '1' && OpenPOP('unverifiedphone')} className="phoneVerificationStatus">
                        <div className="v-image v-responsive theme--light" style={{height: '25px', width: '25px'}}>
                          <div className="v-responsive__sizer" style={{paddingBottom: '100%'}} />
                          <div className="v-image__image v-image__image--contain" style={{backgroundImage: 'url("./static/svg/personal-info-warning.svg")', backgroundPosition: 'center center'}} />
                          <div className="v-responsive__content" style={{width: '19px'}} />
                        </div>
                      </div>
                      <label className="verifyOTPTxt">Verify OTP</label></>
                      )}
                     
                    </div>
                    <div className="col col-12"><hr role="separator" aria-orientation="horizontal" className="v-divider theme--light" /></div>
                  </div>
                  {getotherContracts.length > 0 && (
                            <div className="row px-8 pa-4 hidden-md-and-up no-gutters align-end">
                              <div className="col-md-1 col-lg-1 col-0">
                                <label className="field-name">Secondary Number</label>
                              </div>

                              <div className="phoneNo col-md-9 col-lg-10 col">
                                {getotherContracts.map((contract, index) => (
                                  <label key={index}>+88 {contract.contract_value}</label>
                                ))}
                                
                                
                              </div>
                            </div>
                          )}

                
                          {getotherContracts.length < 2 && (
                  <div onClick={() => OpenPOP('phone')} className="row breakpoint row no-gutters align-end no-gutters px-8 pa-4 pt-0">
                    <div className="pt-0 col-md-6 col-12">
                      <button type="button" className="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default add-mobile-btn-mobile">
                        <span className="v-btn__content">
                          Add secondary number
                        </span>
                      </button>
                    </div>
                  </div>
                    )}
                  <div className="row px-8 pa-4 hidden-md-and-up no-gutters align-end">
                    <div className="col-md-3 col-lg-2 col"><label className="field-name">Fullname</label></div>
                    <div className="col-md-9 col-lg-10 col">{userData.name}<label /></div>
                    <div className="col col-12"><hr role="separator" aria-orientation="horizontal" className="v-divider theme--light" /></div>
                  </div>
                  <div className="row px-8 pa-4 mb-4 hidden-md-and-up no-gutters align-end">
                    <div className="col-md-3 col-lg-2 col"><label className="field-name">Currency</label></div>
                    <div className="col-md-9 col-lg-10 col"><label>BDT</label></div>
                    <div className="col col-12"><hr role="separator" aria-orientation="horizontal" className="v-divider theme--light" /></div>
                  </div>
                </div>
                {verifyType  &&(
            <div onClick={ClosePOP} className="v-overlay v-overlay--active theme--dark" style={{zIndex: 201}}>
                <div className="v-overlay__scrim" style={{opacity: '0.46', backgroundColor: 'rgb(33, 33, 33)', borderColor: 'rgb(33, 33, 33)'}} />
                <div className="v-overlay__content" />
                </div>
                )}
                {verifyType === 'unverifiedphone' &&(
                    <div role="document" tabIndex={0} data-v-c5353408 className="v-dialog__content v-dialog__content--active" style={{zIndex: 202}}>
  <div className="v-dialog v-dialog--active v-dialog--persistent" style={{transformOrigin: 'center center', maxWidth: '400px'}}>
    <div data-v-c5353408 className="dialog-card v-card v-sheet theme--dark">
      <div data-v-c5353408 className="row no-gutters justify-space-between dialog-header pt-3 px-3">
        <div data-v-c5353408 className="col col-11">
          <label data-v-c5353408 className="dialog-title pt-3 ma-0 text-capitalize d-block full-width"> Verify Phone Number</label>
          {/**/}
        </div>
        <div data-v-c5353408 onClick={ClosePOP} className="col col-1"><button data-v-c5353408 type="button" className="v-icon notranslate v-icon--link mdi mdi-close theme--dark dialog-close-icon" /></div>
        {/**/}
      </div>
      <div data-v-c5353408 className="row no-gutters px-3 py-3">
        <div data-v-c5353408 className="col col-12"><hr data-v-c5353408 role="separator" aria-orientation="horizontal" className="dialog-divider v-divider theme--dark" /></div>
      </div>
      <div data-v-c5353408 className="row d-block dialog-row no-gutters pa-3 pt-0">
        <form noValidate="novalidate" className="v-form">
         
          <div className="otpPhoneNo pb-2 mobile">
            <div className="row no-gutters justify-space-between">
              <div className="col col-10">
                <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Phone Number<span className="red--text ml-1">*</span></label>
              </div>
              <div className="col col-2">{/**/}</div>
              <div className="col col-12">
                <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty v-input--is-disabled v-input--is-readonly theme--dark v-text-field v-text-field--prefix v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                  <div className="v-input__control">
                    <div className="v-input__slot">
                      <fieldset aria-hidden="true">
                        <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                      </fieldset>
                      <div className="v-text-field__slot">
                        <div className="v-text-field__prefix">+88</div>
                        <input autoComplete="new-password" disabled="disabled" style={{color: '#000', border: 'none'}} defaultValue={userData.phone} id="input-703" placeholder readOnly="readonly" type="text" />
                      </div>
                    </div>
                    <div className="v-text-field__details">
                      <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pb-5 no-gutters">
            <div className="col col-5">
              <div className="mr-2">
                <button   type="button" className="otp-button theme-button font-weight-bold white--text mr-2 v-btn v-btn--has-bg theme--dark v-size--default primary" style={{height: 'auto'}}>
                    {isCodeSent ? (
                        <span className="v-btn__content">
                            {Math.floor(timer / 60)}:{timer % 60 < 10 ? `0${timer % 60}` : timer % 60}
                        </span>
                    ) : (
                        <span onTouchStart={verfiyPhonCode} onClick={verfiyPhonCode} className="v-btn__content"
                            style={{
                                display: 'inline',
                                pointerEvents: isButtonDisabled ? 'none' : 'auto', 
                                opacity: isButtonDisabled ? 0.5 : 1,
                            }}>
                            Request OTP
                        </span>
                    )}
                  
                </button>
              </div>
            </div>
            <div className="col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">{/**/}</div>
                  <div className="col col-2">{/**/}</div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                          </fieldset>
                          <div className="v-text-field__slot">
                            <input
                                type="text"
                                id="code"
                                style={{color: '#000', border: 'none'}}
                                inputMode="numeric"
                                className="ng-untouched ng-pristine ng-invalid"
                                value={verificationCode}
                                autoComplete="off"
                                onChange={(e) => setVerificationCode(e.target.value)}
                            />
                            </div>
                        </div>
                        <div className="v-text-field__details">
                          <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                        </div>
                      </div>
                    </div>
                    {/**/}{/**/}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row d-flex justify-center align-center no-gutters">
            <button onClick={() => {
                                                verfiyPhoneNumber();
                                                ClosePOP();
                                            }} data-v-1dea3caa type="button" className="full-width font-weight-bold pa-2 otpSubmitButton black--text v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default buttonPrimary theme-button theme--dark subtitle-1">
              <span className="v-btn__content">Submit </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
                    </div>
                )}
                {verifyType === 'phone' &&(
                    <div role="document" tabIndex={0} data-v-c5353408 className="v-dialog__content v-dialog__content--active" style={{zIndex: 202}}>
  <div className="v-dialog v-dialog--active v-dialog--persistent" style={{transformOrigin: 'center center', maxWidth: '400px'}}>
    <div data-v-c5353408 className="dialog-card v-card v-sheet theme--dark">
      <div data-v-c5353408 className="row no-gutters justify-space-between dialog-header pt-3 px-3">
        <div data-v-c5353408 className="col col-11">
          <label data-v-c5353408 className="dialog-title pt-3 ma-0 text-capitalize d-block full-width"> Verify Phone Number</label>
          {/**/}
        </div>
        <div data-v-c5353408 onClick={ClosePOP} className="col col-1"><button data-v-c5353408 type="button" className="v-icon notranslate v-icon--link mdi mdi-close theme--dark dialog-close-icon" /></div>
        {/**/}
      </div>
      <div data-v-c5353408 className="row no-gutters px-3 py-3">
        <div data-v-c5353408 className="col col-12"><hr data-v-c5353408 role="separator" aria-orientation="horizontal" className="dialog-divider v-divider theme--dark" /></div>
      </div>
      <div data-v-c5353408 className="row d-block dialog-row no-gutters pa-3 pt-0">
        <form noValidate="novalidate" className="v-form">
         
          <div className="otpPhoneNo pb-2 mobile">
            <div className="row no-gutters justify-space-between">
              <div className="col col-10">
                <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> First Phone Number<span className="red--text ml-1">*</span></label>
              </div>
              <div className="col col-2">{/**/}</div>
              <div className="col col-12">
                <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty v-input--is-disabled v-input--is-readonly theme--dark v-text-field v-text-field--prefix v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                  <div className="v-input__control">
                    <div className="v-input__slot">
                      <fieldset aria-hidden="true">
                        <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                      </fieldset>
                      <div className="v-text-field__slot">
                        <div className="v-text-field__prefix">+88</div>
                        <input autoComplete="new-password"  style={{color: '#000', border: 'none'}} value={phoneNumber} onChange={(e) => setphoneNumber(e.target.value)} id="input-703" placeholder="01x xxx-xxx-xx"  type="text" />
                      </div>
                    </div>
                    <div className="v-text-field__details">
                      <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pb-5 no-gutters">
            <div className="col col-5">
              <div className="mr-2">
                <button   type="button" className="otp-button theme-button font-weight-bold white--text mr-2 v-btn v-btn--has-bg theme--dark v-size--default primary" style={{height: 'auto'}}>
                    {isCodeSent ? (
                        <span className="v-btn__content">
                            {Math.floor(timer / 60)}:{timer % 60 < 10 ? `0${timer % 60}` : timer % 60}
                        </span>
                    ) : (
                        <span onTouchStart={addPhoneNumber} onClick={addPhoneNumber} className="v-btn__content"
                            style={{
                                display: 'inline',
                                pointerEvents: isButtonDisabled ? 'none' : 'auto', 
                                opacity: isButtonDisabled ? 0.5 : 1,
                            }}>
                            Request OTP
                        </span>
                    )}
                  
                </button>
              </div>
            </div>
            <div className="col">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">{/**/}</div>
                  <div className="col col-2">{/**/}</div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                          </fieldset>
                          <div className="v-text-field__slot">
                            <input
                                type="text"
                                id="code"
                                style={{color: '#000', border: 'none'}}
                                inputMode="numeric"
                                className="ng-untouched ng-pristine ng-invalid"
                                value={verificationCode}
                                autoComplete="off"
                                onChange={(e) => setVerificationCode(e.target.value)}
                            />
                            </div>
                        </div>
                        <div className="v-text-field__details">
                          <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                        </div>
                      </div>
                    </div>
                    {/**/}{/**/}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row d-flex justify-center align-center no-gutters">
            <button onClick={() => {
                                                addverfiyPhoneNumber();
                                                ClosePOP();
                                            }} data-v-1dea3caa type="button" className="full-width font-weight-bold pa-2 otpSubmitButton black--text v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default buttonPrimary theme-button theme--dark subtitle-1">
              <span className="v-btn__content">Submit </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
                    </div>
                )}

                {verifyType === 'edit' && (
                    <div role="document" data-v-c5353408 className="v-dialog__content v-dialog__content--active" style={{zIndex: 202}} tabIndex={0}>
  <div className="v-dialog v-dialog--active v-dialog--persistent" style={{transformOrigin: 'center center', maxWidth: '400px'}}>
    <div data-v-c5353408 className="dialog-card v-card v-sheet theme--dark">
      <div data-v-c5353408 className="row no-gutters justify-space-between dialog-header pt-3 px-3">
        <div data-v-c5353408 className="col col-11">
          <label data-v-c5353408 className="dialog-title pt-3 ma-0 text-capitalize d-block full-width"> Edit Profile</label>
          {/**/}
        </div>
        <div onClick={ClosePOP} data-v-c5353408 className="col col-1"><button data-v-c5353408 type="button" className="v-icon notranslate v-icon--link mdi mdi-close theme--dark dialog-close-icon" /></div>
        {/**/}
      </div>
      <div data-v-c5353408 className="row no-gutters px-3 py-3">
        <div data-v-c5353408 className="col col-12"><hr data-v-c5353408 role="separator" aria-orientation="horizontal" className="dialog-divider v-divider theme--dark" /></div>
      </div>
      <div data-v-c5353408 className="row d-block dialog-row no-gutters pa-3 pt-0">
        <div className="row no-gutters">
          <div />
          <div className="col col-12 px-3">
            <form noValidate="novalidate" className="v-form">
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Email<span className="red--text ml-1">*</span></label>
                  </div>
                  <div className="col col-2">{/**/}</div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                          </fieldset>
                          <div className="v-text-field__slot"><input autoComplete="new-password" value={email} onChange={(e) => setEmail(e.target.value)} id="input-748" style={{color: '#000', border: 'none'}} placeholder="Fill up here" type="text" /></div>
                        </div>
                        <div className="v-text-field__details">
                          <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                        </div>
                      </div>
                    </div>
                    {/**/}{/**/}
                  </div>
                </div>
              </div>
              
              <div className="row no-gutters justify-space-between">
                <div className="col col-12">
                  <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Date of birth<span className="red--text ml-1">*</span></label>
                </div>
              </div>
              <div className="row no-gutters justify-space-between">
                <div className="col col-12">
                  <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                    <div className="v-input__control">
                      <div className="v-input__slot">
                        <fieldset aria-hidden="true">
                          <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                        </fieldset>
                        <div className="v-text-field__slot"><input id="input-756" type='date' style={{color: '#000', border: 'none'}} value={dofb} disabled={!isEditingBirthday}  onChange={(e) => setDofb(e.target.value)} placeholder="DD / MM / YYYY"  /></div>
                        <div className="v-input__append-inner">
                          <div className="v-input__icon v-input__icon--append"><i aria-hidden="true" className="v-icon notranslate material-icons theme--dark">event</i></div>
                        </div>
                      </div>
                      <div className="v-text-field__details">
                        <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                      </div>
                    </div>
                  </div>
                  <div className="v-menu">{/**/}</div>
                </div>
              </div>
              
              <div className="mobile">
                <div className="row no-gutters justify-space-between">
                  <div className="col col-10">
                    <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Fullname<span className="red--text ml-1">*</span></label>
                  </div>
                  <div className="col col-2">{/**/}</div>
                  <div className="col col-12">
                    <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div className="v-input__control">
                        <div className="v-input__slot">
                          <fieldset aria-hidden="true">
                            <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                          </fieldset>
                          <div className="v-text-field__slot"><input id="input-765" style={{color: '#000', border: 'none'}} value={name} onChange={(e) => setName(e.target.value)} placeholder="Fill up here" type="text" /></div>
                        </div>
                        <div className="v-text-field__details">
                          <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                        </div>
                      </div>
                    </div>
                    {/**/}{/**/}
                  </div>
                </div>
              </div>
              <div className="row pb-10 no-gutters">
                <div className="col col-12">
                  <button onClick={() => {
  updateProfile();
  ClosePOP();
}}
 data-v-1dea3caa type="button" className="full-width font-weight-bold pa-2 dialog-button v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default buttonPrimary theme-button theme--dark subtitle-1">
                    <span className="v-btn__content">Submit </span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

                )}


               
              </div>
             
            
            </div>
          </div>
        </div>
      </div>
    </div>
   <Toolbar/>
    <Chat/>
  </div>
</div>

    )
}
export default Profile;